import { captureException } from "@sentry/react"
import ensureError from "@/shared/utils/ensureError"

export const captureMicrofrontendError = (
  error: unknown,
  info: {
    mfeName?: string
    customerId?: string
    errorType?: string
    tags?: Record<string, string>
    context?: Record<string, unknown>
  } = {}
) => {
  captureException(ensureError(error), {
    tags: {
      source: "microfrontend",
      error_type: info.errorType ?? "unknown",
      mfe_name: info.mfeName ?? "unknown",
      customer_id: info.customerId ?? "unknown",
      ...info.tags
    },
    contexts: {
      microfrontend: {
        mfe_name: info.mfeName,
        customer_id: info.customerId,
        ...info.context
      }
    }
  })
}
